<script setup lang="ts">
export interface TcBadgeProps {
  value: number;
  errorClass?: boolean;
}

withDefaults(defineProps<TcBadgeProps>(), {
  errorClass: false,
});
</script>

<template>
  <div
    class="badge"
    :class="{
      'bg-semantic-info': !errorClass,
      'bg-semantic-error': errorClass,
    }"
  >
    <span class="badge__value">{{ value }}</span>
  </div>
</template>

<style lang="scss" scoped>
.badge {
  @include text.general(low, s);
  @include radius(xl);
  @include colors.color(content, inverse);

  width: fit-content;
  min-width: 16px;
  display: flex;
  padding: 2px;

  &__value {
    @include text.modification(center);

    min-width: 16px;
  }
}
</style>
